<template>
  <div class="goal-list-layout pt-10 ">
    <DatepickerWithArrow v-model="_selectedDate" />
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DatepickerWithArrow from '@/components/parts/DatepickerWithArrow.vue'

export default {
  components: {
    DatepickerWithArrow
  },
  computed: {
    ...mapState(['selectedDate']),
    _selectedDate: {
      get() {
        return this.selectedDate
      },
      set(date) {
        this.$store.commit('setSelectedDate', date)
      }
    }
  },
}
</script>